// Warm-up meter (DESIGN.md §5): segmented bar day-1 → mature. Current stage lit, past stages on,
// future stages muted/locked. Stages mirror shared/pacing WARMUP_STAGES (0..5).
const STAGES = 6;

export function WarmUpMeter({ stage }: { stage: number }): JSX.Element {
  return (
    <div className="warmup" role="img" aria-label={`שלב הרצה ${stage} מתוך ${STAGES - 1}`}>
      {Array.from({ length: STAGES }, (_, i) => {
        const cls = i < stage ? 'seg on' : i === stage ? 'seg cur' : 'seg lock';
        return <span key={i} className={cls} />;
      })}
    </div>
  );
}
